import React from 'react'
import PropTypes from 'prop-types'
import { Container, TabList, TabButton } from './styles'

export const TabsBar = ({ tabs, activeTab, onChange, className }) => {
  return (
    <Container className={className}>
      <TabList>
        {tabs.map((tab, index) => (
          <TabButton
            key={tab.id}
            id={tab.id}
            $active={index === activeTab}
            aria-selected={index === activeTab}
            onClick={() => onChange(index)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabList>
    </Container>
  )
}

TabsBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
}
